/* unplugin-vue-components disabled */import { render } from "./test-tools.vue?vue&type=template&id=197c0872&scoped=true"
import script from "./test-tools.vue?vue&type=script&lang=js"
export * from "./test-tools.vue?vue&type=script&lang=js"

import "./test-tools.vue?vue&type=style&index=0&id=197c0872&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197c0872"],['__file',"src/pages/settings/admin/test-tools/test-tools.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "197c0872"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('197c0872', __exports__)) {
    api.reload('197c0872', __exports__)
  }
  
  module.hot.accept("./test-tools.vue?vue&type=template&id=197c0872&scoped=true", () => {
    api.rerender('197c0872', render)
  })

}


export default __exports__